import React from 'react';
import './ComingSoon.css';
import { FaXTwitter, FaInstagram } from 'react-icons/fa6';

// Shown to visitors without the `admin` claim while the site is private.
const ComingSoon = () => (
  <div className="coming-soon">
    <div className="coming-soon-card glass">
      <img
        src="/images/logo.png"
        alt="Dutchess County Bhabani"
        className="cs-logo"
      />
      <span className="cs-eyebrow">নমস্কার • Welcome</span>
      <h1>Coming Soon</h1>
      <p>
        We’re putting the finishing touches on the new home for the Dutchess
        County Bhabani community. Please check back soon.
      </p>
      <div className="cs-socials">
        <a
          href="https://x.com/dcbhabani"
          target="_blank"
          rel="noopener noreferrer"
          className="cs-social"
          aria-label="X (Twitter)"
        >
          <FaXTwitter />
        </a>
        <a
          href="https://instagram.com/dcbhabani"
          target="_blank"
          rel="noopener noreferrer"
          className="cs-social"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
      </div>
    </div>
  </div>
);

export default ComingSoon;
